import { render, staticRenderFns } from "./color-workflow-notification.vue?vue&type=template&id=51d129f5&scoped=true&"
import script from "./color-workflow-notification.vue?vue&type=script&lang=js&"
export * from "./color-workflow-notification.vue?vue&type=script&lang=js&"
import style0 from "./color-workflow-notification.vue?vue&type=style&index=0&id=51d129f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d129f5",
  null
  
)

export default component.exports